import React from "react";
import PdfViewer from "../../PdfViewer";

const MantenimientoCorrectivo = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/ingenieria-mantenimiento-correctivo.pdf`;
  /*const pdfUrl = "/pdf/ingenieria-mantenimiento-correctivo.pdf";*/

  console.log("PDF URL:", pdfUrl);

  return (
    <>
      <main>
        <div class="titulo">
          <h1>Mentenimiento Correctivo</h1>
        </div>
        <div className="pdf-container">
          <PdfViewer pdfUrl={pdfUrl} />
        </div>
      </main>
    </>
  );
};

 export default MantenimientoCorrectivo;
